import { useAppRouter } from '@/common/route/useAppRouter';
import { validateFormat } from '@/common/validator/validatorHelpers';
import { useCrudActions } from '@/common/view/useCrudActions';
import { ROUTE_NAME_BONUS } from '@/modules/bonus/router';
import { bonusService } from '@/services/bonus';
import { useVuelidate } from '@vuelidate/core';
import { maxValue, minValue, required } from '@vuelidate/validators';
import { reactive } from 'vue';
import { useRoute } from 'vue-router';

export function useBonusLoginEdit() {
    const route = useRoute();
    const router = useAppRouter();
    const crudAction = useCrudActions();

    const model = reactive({
        id: route.params.id,
        name: '',
        type: null,
        value: '',
        adsBoost: '',
        adsRescue: 0,
        timeUnit: 0,
        timeDuration: 0,
        startTime: new Date(),
        canDelete: false
    });

    const validations = {
        type: { required },
        timeDuration: { required, min: minValue(1), max: maxValue(32000) },
        value: { required, format: validateFormat(/^\d+(,\d+)*$/) },
        adsBoost: { required, format: validateFormat(/^\d+:\d+(,\d+:\d+)*$/) }
    };

    const v$ = useVuelidate(validations, model);

    const fetch = crudAction.executeAction({
        request: () => bonusService.login.get(model.id),
        onSuccess: ({ data }) => {
            data.startTime = new Date(data.startTime);
            Object.assign(model, data);
        },
        onError: () => router.push({ name: ROUTE_NAME_BONUS.LOGIN.INDEX })
    });

    const actions = {
        update: crudAction.excuteAndNotify({
            validator: v$,
            request: () =>
                bonusService.login.update(
                    model.id,
                    model.name,
                    model.value,
                    model.adsBoost,
                    model.adsRescue,
                    model.timeUnit,
                    model.timeDuration,
                    model?.startTime?.getTime() ?? null
                ),
            onSuccess: () => router.push({ name: ROUTE_NAME_BONUS.LOGIN.INDEX })
        }),
        remove: crudAction.confirmAndRemove({
            request: () => bonusService.login.remove(model.id),
            onSuccess: () => router.push({ name: ROUTE_NAME_BONUS.LOGIN.INDEX })
        })
    };

    return { model, v$, fetch, actions };
}
